import Swal from 'sweetalert2'

export default class RichMessageBox {
    #element

    constructor(element) {
        this.#element = element

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new RichMessageBox(element))
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#handleClick)
    }

    #handleClick = async (event) => {
        event.preventDefault()

        await Swal.fire({
            title: this.#element.dataset.gpTitle,
            icon: this.#element.dataset.gpIcon ?? 'info',
            html: this.#element.querySelector('.gp-rich-message-body').innerHTML,
        })
    }
}
